module.exports = __webpack_public_path__ + "static/media/premium.998343dd.svg";